export default async function (lng: string) {
	const messages = await import(
		`../translations/${process.env.NODE_ENV !== 'production' ? 'defaultLanguage' : lng}.json`
	);

	const routes = await import(
		`../translations/routes/${
			process.env.NODE_ENV !== 'production' ? 'defaultLanguage' : lng
		}.json`
	);

	return { ...messages, ...routes };
}
